import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ResetPasspharseComponent } from '@common-standalone/2fa/reset-passpharse/reset-passpharse.component';
import { SearchComponent } from '@common-standalone/advanced-search/search/search.component';
import { CreateOptionsComponent } from '@common-standalone/file-operations/create-options/create-options.component';
import { DownloadComponent } from '@common-standalone/file-operations/download/download.component';
import { NewCreateBtnComponent } from '@common-standalone/file-operations/new-create-btn/new-create-btn.component';
import { FolderviewComponent } from '@common-standalone/folders/folderview/folderview.component';
import { OtpVerificationComponent } from '@common-standalone/logins/otp-verification/otp-verification.component';
import { ContextMenuComponent } from '@common-standalone/menus/context-menu/context-menu.component';
import { HeaderComponent } from '@common-standalone/menus/header/header.component';
import { LeftMenuComponent } from '@common-standalone/menus/left-menu/left-menu.component';
import { NewLeftMenuComponent } from '@common-standalone/menus/new-left-menu/new-left-menu.component';
import { TopMenuComponent } from '@common-standalone/menus/top-menu/top-menu.component';
import { TabbedViewComponent } from '@common-standalone/tabbed-view/tabbed-view.component';
import { DragDropOverlaysComponent } from '@mainrepo/app/shared-standalone-components/file-operations/drag-drop-overlays/drag-drop-overlays.component';
import { EnablePeopleTabConfirmationComponent } from '@mainrepo/app/shared-standalone-components/people-tab/enable-people-tab-confirmation/enable-people-tab-confirmation.component';
import { PrivateFolderPasswordComponent } from '@mainrepo/app/shared-standalone-components/private-folder/private-folder-password/private-folder-password.component';
import { EmailVerificationComponent } from '@mainrepo/app/shared-standalone-components/promotions/email-verification/email-verification.component';
import { ReferEarnBannerComponent } from '@mainrepo/app/shared-standalone-components/promotions/refer-earn-banner/refer-earn-banner.component';
import { GenericModule } from '@modules/generic/generic.module';
import { PreviewModule } from '@modules/preview/preview.module';
import { UploadOperationsModule } from './upload-operations.module';



@NgModule({
  imports: [
    CommonModule,
    ContextMenuComponent,
    UploadOperationsModule,
    DownloadComponent,
    GenericModule,
    SearchComponent,
    TabbedViewComponent,
    FolderviewComponent,
    ReferEarnBannerComponent,
    EmailVerificationComponent,
    LeftMenuComponent,
    NewLeftMenuComponent,
    OtpVerificationComponent,
    PrivateFolderPasswordComponent,
    ResetPasspharseComponent,
    DragDropOverlaysComponent,
    EnablePeopleTabConfirmationComponent,
    TopMenuComponent,
    CreateOptionsComponent,
    NewCreateBtnComponent,
    PreviewModule,
    HeaderComponent,
    
  ],
  exports:[
    ContextMenuComponent,
    UploadOperationsModule,
    DownloadComponent,
    GenericModule,
    SearchComponent,
    TabbedViewComponent,
    FolderviewComponent,
    ReferEarnBannerComponent,
    EmailVerificationComponent,
    LeftMenuComponent,
    NewLeftMenuComponent,
    PrivateFolderPasswordComponent,
    ResetPasspharseComponent,
    DragDropOverlaysComponent,
    EnablePeopleTabConfirmationComponent,
    TopMenuComponent,
    CreateOptionsComponent,
    NewCreateBtnComponent,
    PreviewModule,
    HeaderComponent,
    OtpVerificationComponent
  ]
})
export class GlobalOperationsModule { }
